"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateVoucherRequestToJSON = exports.CreateVoucherRequestFromJSONTyped = exports.CreateVoucherRequestFromJSON = exports.instanceOfCreateVoucherRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateVoucherRequest interface.
 */
function instanceOfCreateVoucherRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "giveawayId" in value;
    isInstance = isInstance && "expiresAt" in value;
    isInstance = isInstance && "participantId" in value;
    return isInstance;
}
exports.instanceOfCreateVoucherRequest = instanceOfCreateVoucherRequest;
function CreateVoucherRequestFromJSON(json) {
    return CreateVoucherRequestFromJSONTyped(json, false);
}
exports.CreateVoucherRequestFromJSON = CreateVoucherRequestFromJSON;
function CreateVoucherRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'giveawayId': json['giveawayId'],
        'expiresAt': (new Date(json['expiresAt'])),
        'participantId': json['participantId'],
        'participantEntryCount': !(0, runtime_1.exists)(json, 'participantEntryCount') ? undefined : json['participantEntryCount'],
        'participantName': !(0, runtime_1.exists)(json, 'participantName') ? undefined : json['participantName'],
    };
}
exports.CreateVoucherRequestFromJSONTyped = CreateVoucherRequestFromJSONTyped;
function CreateVoucherRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'giveawayId': value.giveawayId,
        'expiresAt': (value.expiresAt.toISOString()),
        'participantId': value.participantId,
        'participantEntryCount': value.participantEntryCount,
        'participantName': value.participantName,
    };
}
exports.CreateVoucherRequestToJSON = CreateVoucherRequestToJSON;
